/* ak-experimental.js — F9. Scroll-linked movement (off for reduced motion):
   - the big LOGO STRIPS slide sideways as you scroll (opposite directions) — they are the "very specific" logo headliners
   - scattered product cards start pushed to their own side and glide toward the MIDDLE as they reach the centre of the screen
   - the floating glass orbs / bubbles in the background drift at their own speeds */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var strips = Array.prototype.slice.call(document.querySelectorAll('[data-strip]'));
  var pars = Array.prototype.slice.call(document.querySelectorAll('[data-par]'));
  var floats = Array.prototype.slice.call(document.querySelectorAll('.ak-bg > i'));
  var ticking = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight, vw = window.innerWidth, y = window.pageYOffset;
    strips.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -300 || r.top > vh + 300) return;
      var dir = parseFloat(el.getAttribute('data-strip')) || 1;
      var x = (r.top + r.height / 2 - vh / 2) * 1.15 * dir;
      el.firstElementChild.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
    });
    pars.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var side = parseFloat(el.getAttribute('data-par')) || 0;
      var p = (r.top + r.height / 2 - vh / 2) / vh; p = Math.max(0, Math.min(1, p));
      var e = p * p * (3 - 2 * p);
      el.style.setProperty('--px', (side * e * vw * (vw < 760 ? 0.1 : 0.08)).toFixed(1) + 'px');
    });
    floats.forEach(function (el, i) { el.style.setProperty('--sy', (-y * (0.04 + i * 0.025)).toFixed(1) + 'px'); });
  }
  function req() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  window.addEventListener('scroll', req, { passive: true });
  window.addEventListener('resize', req);
  req();
})();
